import { downloadFile } from '@/utils/http/http.service';
import Http from '@/utils/http/index';

export default {
  /**
   * 收款方管理
   */
  getPayeeList(params) {
    return Http.get('/payee/list', { params });
  },
  /**
   * 获取银行
   */
  getBankList(params) {
    return Http.get('/baseBank/list', { params });
  },
  /**
   * 上传身份证
   */
  uploadCardUpload(file) {
    const param = new FormData(); // 创建form对象
    param.append('file', file);
    return Http.post('/payee/idCardUpload', param, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  /**
   * 收款人添加
   */
  postAddPayeeVerify(params) {
    return Http.post('/payee/verify', params);
  },
  /**
   * 收款人修改
   */
  postUpdatePayeeVerify(params) {
    return Http.post('/merchant/payee/update', params);
  },
  /**
   * 收款人身份信息
   */
  getPayeeVerifyInfo() {
    return Http.get('/merchant/payee/verifyInfo');
  },
  /**
   * 收款人总信息
   */
  getPayeeInfo(params) {
    return Http.get('/merchant/payee/info', { params });
  },
  /**
   * 设为默认
   */
  postDefaultCard(params) {
    return Http.post('/merchant/payee/defaultAccount', params);
  },
  /**
   * 设为默认
   */
  getImageFile(params) {
    return new Promise((resolve, reject) => {
      Http.get('/collect/getFile', { params, responseType: 'blob' }).then(data => {
        if (data) {
          resolve(window.URL.createObjectURL(data.data));
        } else {
          reject(data);
        }
      }).catch(error => {
        reject(error);
      });
    });
  },
};
